import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dashboardService from "../Services/dashboardService";
import purchaseService from "../Services/purchaseService";
import orderService from "../Services/orderService";
import Loading from "../Modals/Loading";
import BarChart from "../Components/BarChart";
import LogoutModal from "../Components/LogoutModal";
import Cookies from "js-cookie";
import Head from "../Components/Head";
import { ToastBar } from "react-hot-toast";
// Icons
import { FaClock, FaShippingFast } from "react-icons/fa";
import { LuEye, LuPackageCheck } from "react-icons/lu";
import { IoLogOutOutline, IoDocumentText } from "react-icons/io5";
import { BsFillBoxSeamFill } from "react-icons/bs";
import { FaCartShopping, FaCheck } from "react-icons/fa6";
import { IoIosArrowRoundForward } from "react-icons/io";

const Home = () => {
  const [suppliersStats, setSuppliersStats] = useState([]);
  const [customersStats, setCustomersStats] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleDelete = () => {
    setOpen(true);
  };

  const handleLogout = () => {
    setDeleting(true);
    localStorage.removeItem("user");
    Cookies.remove("XIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1LRVk=");
    ToastBar.success("Logout Successfully");
    setDeleting(false);
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    const getStats = async () => {
      try {
        setLoading(true);
        const response = await dashboardService.fetchStats();
        setStats(response.stats);
        setLoading(false);
      } catch {}
    };
    getStats();
    const getSuppliersStats = async () => {
      try {
        setLoading(true);
        const response = await purchaseService.fetchAllSuppliersStats();
        setSuppliersStats(response.purchases);
        setLoading(false);
      } catch {}
    };
    getSuppliersStats();

    const getCustomersStats = async () => {
      try {
        setLoading(true);
        const response = await orderService.fetchAllCustomersStats();
        setCustomersStats(response.orders);
        setLoading(false);
      } catch {}
    };
    getCustomersStats();

    /* const getTotals = async () => {
      try {
        setLoading(true);
        const response = await dashboardService.fetchStats();
        setStatsData(response.purchase);
        setLoading(false);
      } catch {}
    };
    getTotals(); */
  }, []);
  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white">
      {loading === false ? (
        <>
          <div className="flex flex-row justify-between">
            <p className="font-bold text-3xl text-secondary">Dashboard</p>
            <div className={` hover:cursor-pointer`}>
              <IoLogOutOutline size={30} onClick={handleDelete} />
            </div>
          </div>
          <div className="flex flex-row gap-8 mt-10">
            <div className="w-full flex flex-col">
              <h1 className="font-bold text-2xl text-stone-700 mb-2">
                Overview
              </h1>
              <div className="flex flex-row justify-between w-full h-full">
                <div className="bg-gray-100 w-[32%] rounded-3xl p-4">
                  <div className="flex flex-row justify-between items-center">
                    <BsFillBoxSeamFill className="bg-white p-3 rounded-lg shadow-xl w-10 h-10 text-gray-600" />
                    <IoIosArrowRoundForward
                      className="bg-white p-2 rounded-lg shadow-xl w-10 h-10 text-gray-600"
                      onClick={() => navigate("/order")}
                    />
                  </div>
                  <h1 className="text-4xl font-bold mt-14">
                    {stats?.order_count}
                  </h1>
                  <h1 className="text-sm text-gray-500 font-bold tracking-wider whitespace-nowrap">
                    Orders
                  </h1>
                </div>
                <div className="bg-gray-100 w-[32%] rounded-3xl p-4">
                  <div className="flex flex-row justify-between items-center">
                    <FaCartShopping className="bg-white p-3 rounded-lg shadow-xl w-10 h-10 text-gray-600" />
                    <IoIosArrowRoundForward
                      className="bg-white p-2 rounded-lg shadow-xl w-10 h-10 text-gray-600"
                      onClick={() => navigate("/purchase")}
                    />
                  </div>
                  <h1 className="text-4xl font-bold mt-14">
                    {stats?.purchase_count}
                  </h1>
                  <h1 className="text-sm text-gray-500 font-bold tracking-wider whitespace-nowrap">
                    Purchases
                  </h1>
                </div>
                <div className="bg-gray-100 w-[32%] rounded-3xl p-4">
                  <div className="flex flex-row justify-between items-center">
                    <IoDocumentText className="bg-white p-3 rounded-lg shadow-xl w-10 h-10 text-gray-600" />
                    <IoIosArrowRoundForward
                      className="bg-white p-2 rounded-lg shadow-xl w-10 h-10 text-gray-600"
                      onClick={() => navigate("/quotation")}
                    />
                  </div>
                  <h1 className="text-4xl font-bold mt-14">
                    {stats?.quotation_count}
                  </h1>
                  <h1 className="text-sm text-gray-500 font-bold tracking-wider whitespace-nowrap">
                    Quotation
                  </h1>
                </div>
              </div>
            </div>

            <div>
              <h1 className="font-bold text-2xl text-stone-700 mb-2">
                Order Details
              </h1>
              <div>
                <div className="flex flex-col bg-gradient-to-tl from-[#555555] via-[#2e2e2e] to-[#242424] overflow-hidden rounded-3xl p-3">
                  <div className="flex flex-row">
                    {/* Under Process */}
                    <div className="w-48 p-2 border-r border-b border-white/20">
                      <div className="flex flex-row items-center gap-2">
                        <FaClock className="text-red-600 h-8 w-8 bg-white/20 p-2 rounded-full" />
                        <h1 className="text-gray-400 font-bold text-xs">
                          Under Process
                        </h1>
                      </div>
                      <h1 className="text-white font-semibold text-3xl text-center">
                        {stats?.underprocess_order_count}
                      </h1>
                    </div>

                    {/* Confirmed */}
                    <div className="w-48 p-2 border-l border-b border-white/20">
                      <div className="flex flex-row items-center gap-2">
                        <FaCheck className="text-blue-600 h-8 w-8 bg-white/20 p-2 rounded-full" />
                        <h1 className="text-gray-400 font-bold text-xs">
                          Confirmed
                        </h1>
                      </div>
                      <h1 className="text-white font-semibold text-3xl text-center">
                        {stats?.confirmed_order_count}
                      </h1>
                    </div>
                  </div>

                  <div className="flex flex-row">
                    {/* Ready For Shipment */}
                    <div className="w-48 p-2 border-r border-t border-white/20">
                      <div className="flex flex-row items-center gap-2">
                        <FaShippingFast className="text-amber-500 h-8 w-8 bg-white/20 p-2 rounded-full" />
                        <h1 className="text-gray-400 font-bold text-xs">
                          Ready For Shipment
                        </h1>
                      </div>
                      <h1 className="text-white font-semibold text-3xl text-center">
                        {stats?.readytodeliver_order_count}
                      </h1>
                    </div>

                    {/* Delivered */}
                    <div className="w-48 p-2 border-l border-t border-white/20">
                      <div className="flex flex-row items-center gap-2">
                        <LuPackageCheck className="text-green-600 h-8 w-8 p-2 bg-white/20 rounded-full" />
                        <h1 className="text-gray-400 font-semibold text-xs">
                          Delivered
                        </h1>
                      </div>
                      <div className="flex justify-center items-center">
                        <h1 className="text-white font-semibold text-3xl text-center">
                          {stats?.delivered_order_count}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-between h-full mt-4">
            <h1 className="font-bold text-2xl text-gray-700 mb-4">Analysis</h1>
            <div className="w-full max-h-[295px] h-[295px] bg-white border rounded-lg p-3 overflow-hidden">
              <BarChart />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 mt-10">
            {/* Supplier Table */}
            <div className="my-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white">
              <Head
                heading={"Suppliers"}
                button_text={"Download"}
                navigation={() => {
                  const headers = [
                    "Company Name",
                    "Total Purchases",
                    "Total Paid",
                    "Remaining Balance",
                  ];
                  const rows = suppliersStats.map((supplier) => [
                    supplier.company,
                    parseFloat(supplier.total_amount).toFixed(2),
                    parseFloat(supplier.total_paid_amount).toFixed(2),
                    (
                      parseFloat(supplier.total_amount || 0) -
                      parseFloat(supplier.total_paid_amount || 0)
                    ).toFixed(2),
                  ]);
                  let csvContent =
                    "data:text/csv;charset=utf-8," +
                    [headers, ...rows].map((e) => e.join(",")).join("\n");
                  const encodedUri = encodeURI(csvContent);
                  const link = document.createElement("a");
                  link.setAttribute("href", encodedUri);
                  link.setAttribute("download", "suppliers.csv");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              />
              <div className="table-div">
                <div className="max-h-[425px] overflow-y-auto scrollbar-hide rounded-b-xl">
                  <table className="w-full">
                    <thead>
                      <tr className="border-y-2 text-left text-black text-[10px] sticky top-0 bg-white z-50">
                        <th className="text-center text-red-600 w-[3%] py-4">
                          Company Name
                        </th>
                        <th className="text-center w-[3%] py-4">
                          Total Purchases
                        </th>
                        <th className="text-center w-[3%] py-4">Total Paid</th>
                        <th className="text-center w-[3%] py-4">
                          Remaining Balance
                        </th>
                        <th className="rounded-tr-xl text-center w-[1%] py-4">
                          View
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {suppliersStats?.map((supplier, index) => (
                        <tr
                          key={index}
                          className="bg-accent border-b border-gray-100 text-left"
                        >
                          <td className="py-4 text-center text-[10px] font-semibold w-[3%]">
                            {supplier.company}
                          </td>
                          <td className="py-4 text-center text-[10px] w-[3%]">
                            {parseFloat(supplier.total_amount).toFixed(2)} AED
                          </td>
                          <td className="py-4 text-center text-[10px] w-[3%]">
                            {parseFloat(supplier.total_paid_amount).toFixed(2)}{" "}
                            AED
                          </td>
                          <td className="py-4 text-center text-[10px] w-[3%]">
                            {(
                              parseFloat(supplier.total_amount || 0) -
                              parseFloat(supplier.total_paid_amount || 0)
                            ).toFixed(2)}{" "}
                            AED
                          </td>
                          <td className="py-4 text-center text-base w-[1%]">
                            <LuEye
                              className="mx-auto cursor-pointer text-sky-600"
                              onClick={() =>
                                navigate(
                                  `/suppliers/ledger?id=${supplier.supplier}`,
                                )
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* Customer Table */}
            <div className="my-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white">
              <Head
                heading={"Customers"}
                button_text={"Download"}
                navigation={() => {
                  const headers = [
                    "Company Name",
                    "Total Sale",
                    "Total Received",
                    "Remaining Balance",
                  ];
                  const rows = customersStats.map((customer) => [
                    customer.company_name,
                    parseFloat(customer.total_vat_amount).toFixed(2),
                    parseFloat(customer.total_transaction_amount).toFixed(2),
                    (
                      parseFloat(customer.vat_amount_underprocess || 0) -
                      (parseFloat(customer.total_transaction_amount || 0) +
                        parseFloat(customer.total_receivable || 0))
                    ).toFixed(2),
                  ]);
                  let csvContent =
                    "data:text/csv;charset=utf-8," +
                    [headers, ...rows].map((e) => e.join(",")).join("\n");
                  const encodedUri = encodeURI(csvContent);
                  const link = document.createElement("a");
                  link.setAttribute("href", encodedUri);
                  link.setAttribute("download", "customers.csv");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              />
              <div className="table-div">
                <div className="max-h-[425px] overflow-y-auto scrollbar-hide rounded-b-xl">
                  <table className="w-full">
                    <thead>
                      <tr className="border-y-2 text-left text-black text-[10px] sticky top-0 bg-white z-50">
                        <th className="rounded-tl-xl text-center text-red-600 w-[3%] py-4">
                          Company Name
                        </th>
                        <th className="text-center w-[3%] py-4">Total Sale</th>
                        <th className="text-center w-[3%] py-4">
                          Total Received
                        </th>
                        <th className="text-center w-[3%] py-4">
                          Remaining Balance
                        </th>
                        <th className="rounded-tr-xl text-center w-[1%] py-4">
                          View
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {customersStats?.map((customer, index) => (
                        <tr
                          key={index}
                          className="bg-accent border-b border-gray-100 text-left"
                        >
                          <td className="py-4 text-center text-[10px] font-bold px-2 w-[3%]">
                            {customer.company_name}
                          </td>
                          <td className="py-4 text-center text-[11px] w-[3%] bg-white">
                            {parseFloat(customer.total_vat_amount).toFixed(2)}{" "}
                            AED
                          </td>
                          <td className="py-4 text-center text-[11px] w-[3%]">
                            {parseFloat(
                              customer.total_transaction_amount,
                            ).toFixed(2)}{" "}
                            AED
                          </td>
                          <td className="py-4 text-center text-[11px] w-[3%]">
                            {(
                              parseFloat(
                                customer.vat_amount_underprocess || 0,
                              ) -
                              (parseFloat(
                                customer.total_transaction_amount || 0,
                              ) +
                                parseFloat(customer.total_receivable || 0))
                            ).toFixed(2)}{" "}
                            AED
                          </td>
                          <td className="py-4 text-center text-base w-[1%]">
                            <LuEye
                              className="mx-auto cursor-pointer text-sky-600"
                              onClick={() =>
                                navigate(
                                  `/customers/ledger?id=${customer.customer}`,
                                )
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <LogoutModal
              open={open}
              setOpen={setOpen}
              deleteFunction={handleLogout}
              deleting={deleting}
            />
          </div>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default Home;
